import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateConverter'
})
export class ConverterStringToDateString implements PipeTransform {

    transform(val): string {

        if (!val) return val;

        let date = String(val).split(' ');
        let arr = String(date[0]).split('.');
        val = Date.parse(`${arr[2]}-${arr[1]}-${arr[0]}T${date[1]}`);

        return val;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/pipes/date.converter.pipe.ts